<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item url="/dashboard-default" :class="getRoute() == 'dashboard-default' ? 'active' : ''"
          navText="Métricas" v-if="user?.role == '1' || user?.role == '2'">
          <template v-slot:icon>
            <i class="fas fa-home text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '3'">
        <sidenav-item url="/operador/dashboard" :class="getRoute() == 'operador/dashboard' ? 'active' : ''"
          navText="Métricas">
          <template v-slot:icon>
            <i class="fas fa-home text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '1' || user?.role == '2'">
        <sidenav-item url="/pos" :class="getRoute() == 'pos' ? 'active' : ''" navText="POS">
          <template v-slot:icon>
            <i class="fas fa-cash-register text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '1' || user?.role == '2'">
        <sidenav-item url="/cash-sessions" :class="getRoute() == 'cash-sessions' ? 'active' : ''" navText="Cierres de caja">
          <template v-slot:icon>
            <i class="fas fa-clipboard-list text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '3'">
        <sidenav-item url="/operador/pos" :class="getRoute() == 'operador/pos' ? 'active' : ''" navText="POS">
          <template v-slot:icon>
            <i class="fas fa-cash-register text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('usuarios')">
        <sidenav-item url="/users" :class="getRoute() == 'users' ? 'active' : ''" navText="Usuarios">
          <template v-slot:icon>
            <i class="fas fa-users text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '3'">
        <sidenav-item url="/operador/ventas" :class="getRoute() == 'operador/ventas' ? 'active' : ''"
          navText="Ventas / Ingresos">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('insumos')">
        <sidenav-item url="/inventory" :class="getRoute() == 'inventory' ? 'active' : ''" navText="Inventario">
          <template v-slot:icon>
            <i class="fas fa-box text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('insumos')">
        <sidenav-item url="/promotions" :class="getRoute() == 'promotions' ? 'active' : ''" navText="Promociones">
          <template v-slot:icon>
            <i class="fas fa-percent text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('compras')">
        <sidenav-item url="/purchases" :class="getRoute() == 'purchases' ? 'active' : ''" navText="Compras / Salidas">
          <template v-slot:icon>
            <i class="fas fa-shopping-cart text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('remisiones')">
        <sidenav-item url="/remissions" :class="getRoute() == 'remissions' ? 'active' : ''" navText="Ventas / Ingresos">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '1' || user?.role == '2'">
        <a class="nav-link cursor-pointer" :class="isConfigActive ? 'active' : ''" @click="toggleConfigDropdown">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="fas fa-cog text-warning text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">Configuración</span>
          <i class="fa ms-auto" :class="configDropdownOpen ? 'fa-chevron-down' : 'fa-chevron-right'" style="font-size: 0.7rem;"></i>
        </a>
        <ul class="nav config-subnav" v-show="configDropdownOpen">
          <li style="width:80%">
            <router-link to="/settings/general" class="nav-link config-sublink" :class="{ active: $route.path === '/settings/general' || $route.path === '/settings' }">
              <i class="fas fa-sliders-h text-xs opacity-6 me-2"></i>
              <span class="nav-link-text">General</span>
            </router-link>
          </li>
          <li style="width:80%">
            <router-link to="/settings/bodegas" class="nav-link config-sublink" :class="{ active: $route.path === '/settings/bodegas' }">
              <i class="fas fa-warehouse text-xs opacity-6 me-2"></i>
              <span class="nav-link-text">Bodegas</span>
            </router-link>
          </li>
          <li style="width:80%">
            <router-link to="/settings/categorias" class="nav-link config-sublink" :class="{ active: $route.path === '/settings/categorias' }">
              <i class="fas fa-tags text-xs opacity-6 me-2"></i>
              <span class="nav-link-text">Categorías</span>
            </router-link>
          </li>
          <li style="width:80%">
            <router-link to="/settings/colecciones" class="nav-link config-sublink" :class="{ active: $route.path === '/settings/colecciones' }">
              <i class="fas fa-layer-group text-xs opacity-6 me-2"></i>
              <span class="nav-link-text">Referencias</span>
            </router-link>
          </li>
          <li style="width:80%">
            <router-link to="/settings/disenos" class="nav-link config-sublink" :class="{ active: $route.path === '/settings/disenos' }">
              <i class="fas fa-paint-brush text-xs opacity-6 me-2"></i>
              <span class="nav-link-text">Diseños</span>
            </router-link>
          </li>
          <li style="width:80%">
            <router-link to="/settings/colores" class="nav-link config-sublink" :class="{ active: $route.path === '/settings/colores' }">
              <i class="fas fa-palette text-xs opacity-6 me-2"></i>
              <span class="nav-link-text">Colores</span>
            </router-link>
          </li>
          <li style="width:80%">
            <router-link to="/settings/tallas" class="nav-link config-sublink" :class="{ active: $route.path === '/settings/tallas' }">
              <i class="fas fa-ruler text-xs opacity-6 me-2"></i>
              <span class="nav-link-text">Tallas</span>
            </router-link>
          </li>
        </ul>
      </li>

      <li class="nav-item" v-if="false">
        <sidenav-item url="/reports" :class="getRoute() == 'reports' ? 'active' : ''" navText="Informes">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>


    </ul>
  </div>
  <div class="mx-3 sidenav-footer text-center mt-3">


  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";


export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      dropDownStatus: true,
      configDropdownOpen: false,
      user: {}
    };
  },
  components: {
    SidenavItem,
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem('user'));
    console.log(user);
    if (user) {
      this.user = user;
    }
  },
  methods: {
    /** Si el usuario es supervisor (role 2), solo muestra el ítem si tiene el módulo activo en supervisor_modules. Si es admin (role 1) u otro, muestra según la regla original. */
    showModule(moduleKey) {
      if (!this.user) return false;
      const role = this.user.role;
      // Administrador: ve todo (usuarios, modelo, produccion, operaciones, inventario, insumos, compras, remisiones, nomina)
      if (role === '1' || role === 1) return true;
      // Supervisor: solo si tiene el módulo en supervisor_modules
      if (role === '2' || role === 2) {
        const mods = Array.isArray(this.user.supervisor_modules)
          ? this.user.supervisor_modules
          : (typeof this.user.supervisor_modules === 'string' ? (this.user.supervisor_modules ? JSON.parse(this.user.supervisor_modules) : []) : []);
        return mods && mods.includes(moduleKey);
      }
      return false;
    },
    getRoute() {
      const path = this.$route.path;
      // Si la ruta es de operador, devolver la ruta completa sin la barra inicial
      if (path.startsWith('/operador/')) {
        return path.substring(1); // Remover la barra inicial: '/operador/dashboard' -> 'operador/dashboard'
      }
      // Para otras rutas, devolver solo la primera parte
      const routeArr = path.split("/");
      return routeArr[1] || '';
    },
    useDropDown() {
      this.dropDownStatus = !this.dropDownStatus;
    },
    toggleConfigDropdown() {
      this.configDropdownOpen = !this.configDropdownOpen;
    },

  },
  computed: {
    isConfigActive() {
      return this.$route.path.startsWith('/settings');
    },
  },
};
</script>

<style scoped>
.config-subnav {
  list-style: none;
  padding: 0;
  margin: 0;
  border-left: 2px solid rgba(0, 0, 0, 0.06);
  margin-left: 1.25rem;
}

.config-subnav li {
  list-style: none;
}

.config-sublink {
  display: flex;
  align-items: center;
  padding: 0.35rem 0.75rem 0.35rem 1rem;
  margin: 0;
  font-size: 0.8rem;
  color: #6c757d;
  border-radius: 0 0.375rem 0.375rem 0;
  transition: all 0.15s ease;
  text-decoration: none;
  line-height: 1.4;
  width: 100%;
}

.config-sublink:hover {
  background-color: rgba(94, 114, 228, 0.08);
  color: #5e72e4;
}

.config-sublink.active,
.config-sublink.router-link-exact-active {
  background-color: rgba(94, 114, 228, 0.12);
  color: #5e72e4;
  font-weight: 600;
  width: 100%;
}

.config-sublink .nav-link-text {
  white-space: nowrap;
}
</style>
